import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Root Component - ModuleList
 */
const ModuleList = React.forwardRef(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn(
      'c-module-list',
      // styles
      'relative flex w-full list-none flex-col gap-1 p-0',
      className
    )}
    {...props}
  />
));
ModuleList.displayName = 'ModuleList';

/**
 * Sub-component - ModuleListItem
 */
const ModuleListItem = React.forwardRef(({ className, active, disabled, ...props }, ref) => (
  <li
    ref={ref}
    data-active={active}
    className={cn(
      'c-module-list-item group', // 'group' permite que os filhos usem group-hover ou group-data-active
      'relative rounded-[10px] border border-neutral-lightest bg-white p-4',
      'flex cursor-pointer items-start gap-2 transition-all duration-200 ease-in-out',
      // Estilos de Hover e Ativo no Contentor
      'hover:bg-primary data-[active=true]:bg-primary',
      'hover:text-white data-[active=true]:text-white',
      '[&_svg]:transition-colors [&_svg]:duration-200',
      '[&_svg]:!fill-current [&_svg]:!stroke-current',
      disabled && 'cursor-default opacity-70 hover:bg-white hover:text-inherit',
      className
    )}
    {...props}
  />
));
ModuleListItem.displayName = 'ModuleListItem';

/**
 * Sub-component - ModuleListTitle
 */
const ModuleListTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-module-list-title',
      // styles
      'mb-0 mr-4 w-0 flex-grow break-words text-sm font-bold text-primary-dark transition-colors duration-200',
      'group-hover:text-white',
      'group-data-[active=true]:text-white',
      className
    )}
    {...props}
  />
));
ModuleListTitle.displayName = 'ModuleListTitle';

export { ModuleList, ModuleListItem, ModuleListTitle };
